import React, { Fragment, useState, useEffect } from "react";
import Topbar from "../layouts/TopBar";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import AbsenceResources from "../resources/AbsenceResources";
import UserResources from "../resources/UserResources";
import LocationResources from "../resources/LocationResources";
import toast from 'react-hot-toast';
import moment from "moment/moment";
import Select from 'react-select';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { connect } from "react-redux";
import {  logout } from "../redux/actions/LoggedInAction";
import { addMonths } from 'date-fns';
import {ACCESS_DENIED} from '../Messages'

function ManageAbsences({isLoggedIn, loggedInUser}){   
  const [absences, setAbsences] = useState([])
  const [locations, setLocations] = useState([])
  const [selectedLocation, setSelectedLocation] = useState('') 
  const [users, setUsers] = useState([])

  const [dateSelectionViewerRange, setDateSelectionViewerRange] = useState({
    startDate: new Date(),
    endDate: addMonths(new Date(), 1),
    key: 'selectionViewer',
  });
  
  const oneYearAgo = addMonths(new Date(), -12);
  const oneYearLater = addMonths(new Date(), 12);

  const locationResources = new LocationResources()
  const absenceResources = new AbsenceResources()

    const loadAbsences = (absence) => {
        let resources = new AbsenceResources()
        return resources.post_filtered(absence)
    }

    const loadUsers = () => {
        let userResources = new UserResources()
        return userResources.get_admin()
    }

    const loadLocations = () => {
        return locationResources.get()
    }

       
      const handleLocationSelection = (location) => {
        setSelectedLocation(location.value);
    };


      const handleDateSelectViewerRange = (ranges) => {
        setDateSelectionViewerRange(ranges.selectionViewer);
        
      };

      let mediaLocations = []  
      locations.map((loc, index) => (
          mediaLocations.push({value: loc['id'], label: loc['name'] })
      ))
      
  
      // Function to handle button clicks
      const handleDeleteAbsenceButtonClick = (id, user_id) => {      
        let absence = {};
        absence['id'] = Number(id)
        absence['user_id'] = user_id

        absenceResources.delete_absence(absence).then(res => {
            if (res.error.length < 1) {
                toast.success("Absence removed")
                setTimeout(() => {
                    window.location.href = window.location.origin + '/absences';
                  }, 200);
            }else if(res.error === 'You do not have permission to make this change') {
                toast.error("You do not have permission to make this change.")
            }
             else {
                //toast.error("Operation Failed: " + res.error);
                toast.error("An Issue occured, please retry")
            }
            }).catch((err) => {
                toast.error("Network Error: " + err);
            });
      
  
      };    
      
      const handleLoadAbsencesButtonClick = (id) => {      
        let absence = {};
        if(Object.keys(dateSelectionViewerRange).length === 0)
            {
              toast.error("Please Select the date range you want to filter by")
              return;
            }

        if(Object.keys(selectedLocation).length === 0)
            {
                toast.error("Please Select the Location you want to filter by")
                return;
            }

        absence['start_date'] = moment( dateSelectionViewerRange['startDate']).format('YYYY-MM-DD HH:mm:ss') 
        absence['end_date'] = moment( dateSelectionViewerRange['endDate']).format('YYYY-MM-DD HH:mm:ss')     
        absence['location_id'] = Number(selectedLocation)
        
        loadAbsences(absence).then(res => {
            if (res.error.length < 1) {
                setAbsences(res['body']);
            }
             else {
                //toast.error("Operation Failed: " + res.error);
                toast.error("An Issue occured, please retry")
            }
            }).catch((err) => {
                toast.error("Network Error: " + err);
            });
      
  
      };     

    useEffect(() => {
        loadLocations().then(response => {
            setLocations(response['body']);
        }).catch((err) => {
            toast.error("Network error: " + err)
        });

        loadUsers().then(response => {
            setUsers(response['body']);
        }).catch((err) => {
            toast.error("Network error: " + err)
        });
    }, []);

    let members = []  //dropdown values is the user information
    users.map((user, index) => (
        members.push({value: user, label: user['firstname'] + " " + user['lastname'] })
    ))

    return(
        <Fragment>
            <Topbar/>

            <div className="hero-area">
            <div className="page-banner parallax" style={{backgroundColor:"#003165"}}>
                    <div className="container">
                        <div className="page-banner-text">
                        {isLoggedIn ?
                                <h1 style={{color:"#ffa800"}} className="block-title"><strong>Manage Absences</strong></h1>
                                :
                                <h1 style={{color:"#ffa800"}} className="block-title"><strong>{ACCESS_DENIED}</strong></h1>
                            }
                            
                        </div>
                    </div>
                </div>
            </div>

            <div id="main-container">
                {
                    isLoggedIn ? 
                
                <div className="content">
                    <div className="container">  
                    
                    <div className="row">                
                        <div className="col-md-6">                                            
                            <DateRangePicker
                                    editableDateInputs
                                    onChange={handleDateSelectViewerRange}
                                    moveRangeOnFirstSelection={false}
                                    ranges={[dateSelectionViewerRange]}
                                    minDate={oneYearAgo}
                                    maxDate={oneYearLater}
                                />                                        
                                            
                        </div>
                        <div className="col-md-6">
                                           
                                            <Select
                                                name='requirements'
                                                id="requirements"
                                                classNamePrefix='select-css-tag'
                                                //value={selectedOption}
                                                onChange={handleLocationSelection}
                                                options={mediaLocations}
                                                placeholder="Select Location" 
                                                />     
                                            <div className="spacer-40"></div><div className="spacer-40"></div>
                                            <button style={{marginLeft:'30px', color: '#003165'}} onClick={handleLoadAbsencesButtonClick}>Load Absences</button>

                        </div> 
                        <div className="spacer-40"/>
                    </div>  
                    <h2 style={{color:"#ffa800"}}>
                        <strong>
                            {moment(dateSelectionViewerRange.startDate).format('MMM DD')} - {moment(dateSelectionViewerRange.endDate).format('MMM DD, YYYY')} Absences
                        </strong>
                    </h2>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                <TableRow>
                                    <TableCell></TableCell>
                                    <TableCell><strong>First Name</strong></TableCell>
                                    <TableCell><strong>Last Name</strong></TableCell>
                                    <TableCell><strong>Location</strong></TableCell>
                                    <TableCell><strong>Start Date</strong></TableCell>
                                    <TableCell><strong>End Date</strong></TableCell>
                                    <TableCell><strong>Reason</strong></TableCell>
                                </TableRow>
                                </TableHead>
                                <TableBody>
                                {absences.map((absence) => (
                                    <TableRow key={absence['id']}>
                                    <TableCell>
                                        <img
                                            src={absence['user.image']}
                                            alt={`${absence['user.firstname']} ${absence['user.lastname']}`}
                                            style={{
                                                width: '50px',
                                                height: '50px',
                                                borderRadius: '50%',
                                                objectFit: 'cover',
                                                border: '2px solid #ffa800'
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell>{absence['user.firstname']}</TableCell>
                                    <TableCell>{absence['user.lastname']}</TableCell>
                                    <TableCell>{absence['user.location.name']}</TableCell>
                                    <TableCell>{moment( absence['start_date']).format('DD MMMM YYYY')}</TableCell>
                                    <TableCell>{moment( absence['end_date']).format('DD MMMM YYYY')}</TableCell>
                                    <TableCell>{absence['reason']}</TableCell>
                                    <TableCell>{ loggedInUser !== null && loggedInUser['role.name'] === 'admin'? <button style={{marginLeft: "10px"}} onClick={() => handleDeleteAbsenceButtonClick(absence['id'], absence['user_id'])} >Remove</button> : <p></p>}</TableCell>
                                    </TableRow>
                                ))}
                                </TableBody>
                            </Table>
                        </TableContainer>    
                                            
                        

                            
                    </div>
                </div> : <></>
        }
            </div>

        </Fragment>
    )
}

const mapStateToProps = (state) => {
    return{
       isLoggedIn: state.authReducer.isLoggedIn,
       loggedInUser: state.authReducer.user
    };
    
};

const mapDispatchToProps = {
    logout
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageAbsences);